module.exports = __webpack_public_path__ + "img/right-top-shape.902461f6.svg";